<template>
  <li>
    <div
      :class="[
        selectedPath === parentPath + 'text' ? 'focused' : '',
        errorPath.includes(parentPath + 'text') ? 'has-error' : '',
      ]"
      @click="selectNode(text, parentPath + 'text')"
      @mouseenter="isHover = true"
      @mouseleave="isHover = false"
    >
      <span class="node-icon q-mr-xs">
        <q-icon
          size="xs"
          :name="showChild ? 'arrow_drop_down' : 'arrow_right'"
          @click="showChild = !showChild"
          v-if="text.contents && text.contents.length > 0"
        />
        <q-icon
          size="xs"
          name="text_fields"
          v-else
        />
      </span>
      <span v-if="text.contents && text.contents.length > 0">text</span>
      <span v-else>text [{{ text.text.length > 9 ? text.text.slice(0, 9) + '...' : text.text }}]</span>
    </div>
    <ul v-if="text.contents && text.contents.length > 0" :style="!showChild ? 'display: none;' : ''">
      <template v-for="(item, index) in text.contents" :key="index">
        <Span
          :span="item"
          :parentPath="parentPath + 'text-' + index + '.'"
          :selectedNode="selectedNode"
          :selectedPath="selectedPath"
          :errorPath="errorPath"
          @onSelectNode="selectNode"
          @onHoverNode="(val) => $emit('onHoverNode', val)"
        />
      </template>
    </ul>
  </li>
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component'
import { maska } from 'maska'
import { Prop, Watch } from 'vue-property-decorator'
import {
  IFlexMessageBox,
  IFlexMessageBubble,
  IFlexMessageButton,
  IFlexMessageCarousel,
  IFlexMessageFiller,
  IFlexMessageIcon,
  IFlexMessageImage,
  IFlexMessageSeparator,
  IFlexMessageSpan,
  IFlexMessageText, IFlexMessageVideo,
} from '@/utils/types'
import Span from '@/components/common/flex-message/nodes/Span.vue'

@Options({
  components: { Span },
  directives: { maska },
  emits: ['onSelectNode', 'onHoverNode'],
})
export default class Text extends Vue {
  @Prop()
  text!: IFlexMessageText

  @Prop()
  selectedNode!: IFlexMessageCarousel | IFlexMessageBubble | IFlexMessageBox | IFlexMessageButton | IFlexMessageFiller | IFlexMessageIcon | IFlexMessageImage | IFlexMessageSeparator | IFlexMessageSpan | IFlexMessageText | IFlexMessageVideo

  @Prop()
  selectedPath!: string

  @Prop()
  parentPath!: string

  @Prop()
  errorPath!: string[]

  showChild = true

  isHover = false

  selectNode(node, path) {
    if (this.selectedNode === node && this.selectedPath === path) {
      this.$emit('onSelectNode', undefined, '')
    } else {
      this.$emit('onSelectNode', node, path)
    }
  }

  @Watch('isHover')
  onHover() {
    if (this.isHover) {
      this.$emit('onHoverNode', this.parentPath + 'text')
    }
  }
}
</script>

<style scoped lang="scss">

</style>
